import "./index.css";

const Lines = () => {
  return (
    <div className="base-lines">
      <div className="base-lines-item"></div>
      <div className="base-lines-item"></div>
      <div className="base-lines-item"></div>
      <div className="base-lines-item"></div>
      <div className="base-lines-item"></div>
    </div>
  );
};

export default Lines;
